import { cn } from '@/app/utils'

type Props = {
  rows: number
  className?: string
  itemClassName?: string
}

export const TableSkeleton = ({ rows, className, itemClassName }: Props) => {
  return (
    <ul className={className} data-testid="skeleton-table-id">
      {Array.from({ length: rows }).map((_, index) => (
        <li
          key={index}
          className={cn(
            'mb-12 h-[92px] animate-pulse rounded-12 bg-[rgba(16,24,32,.1)]',
            itemClassName
          )}
        />
      ))}
    </ul>
  )
}
